import _ from 'lodash'
import ChooseCannedReportStep from '../choose-report/choose-canned-report-step'
import template from './choose-initiative-report-step.hbs'
import InitiativeReportModel from 'scoreboard/reports/initiative-report/initiative-report-model'

const reportTypes = {
	'initiative-report-designer': {
		icon: 'settings',
		key: 'report.designer.advancedReport',
		model: InitiativeReportModel
	}
}

const Path = {
	steps: [{
		titleCode: 'report.designer.chooseAnItem',
		view: ChooseCannedReportStep,
		viewOptions: {
			template,
			reportTypes
		},
		validate: function (attrs, opts) {
			return _.isNil(attrs.reportType)
		}
	}]
}

export default Path

Path.__filename__ = 'reports/wizard/initiative-report/initiative-report-path.js'
